
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

export function insertTable (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/table',
    method: 'POST',
    data: parameter
  })
}
export function updateTable (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/table',
    method: 'PUT',
    data: parameter
  })
}
export function deleteTable (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/table',
    method: 'DELETE',
    params: {
      id: parameter
    }
  })
}
export function getTableList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/table',
    method: 'GET',
    params: parameter
  })
}
export function getTableInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/table',
    method: 'GET',
    params: parameter
  })
}
